<template>
  <el-checkbox-group v-model="val" class="flex aic">
    <template v-for="(item,idx) in list">
      <el-checkbox class="flex0" :label="item.value" :key="idx" v-if="item.id" @change="change(idx)">
        <div class="flex aic">
          <span class="flex0 mr10">{{ item.label }}</span>
          <el-upload class="flex0 mr30" :action="UPLOAD_URL" :data="UPLOAD_PARAMS"
                     :headers="UPLOAD_HEADERS"
                     :before-upload="beforeUpload"
                     :show-file-list="false" :on-success="onSuccess(idx)">
            <img :src="inputVal[idx]" v-if="inputVal[idx]" alt="" class="avatar-uploader-icon">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </el-checkbox>
    </template>
  </el-checkbox-group>
</template>

<script>
import {UploadMixin} from "@/common/lib/mixins/upload";

export default {
  name: "staff-checkbox-group-pic",
  mixins: [UploadMixin],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      val: [],
      inputVal: []
    }
  },
  computed: {
    list() {
      return this.data.map((r, i) => {
        if (typeof r === 'string') {
          return {
            value: i,
            label: r
          }
        }
        return {
          ...r
        }
      });
    }
  },
  watch: {
    data: {
      handler() {
        this.initInputVal();
      },
      deep: true
    },
    value(newV) {
      if (!this.equal(newV, this.val)) {
        this.val = newV.map(r => parseInt(r));
        Log('butong')
      }
    },
    val: {
      handler(newV) {
        if (!this.equal(newV, this.value))
          this.$emit('input', newV);
      },
      deep: true
    },
    inputVal(newV) {
      let obj = {};
      newV.forEach((r, i) => {
        let extra = this.list[i];
        obj[extra.id] = r;
      });
    }
  },
  created() {
    this.val = this.value;
    this.initInputVal();
  },
  methods: {
    change(index) {
      Log(index)
      this.list.forEach((r, i) => {
        if (i === index && !this.val.includes(i)) {
          this.inputVal.splice(i, 1, '');
          this.$emit('inputChange', {
            [r.id]: ''
          })
        }
      });
    },
    equal(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      for (let i = 0; i < arr1.length; i++) {
        if (arr2.indexOf(arr1[i]) < 0) return false;
      }
      return true;
    },
    onSuccess(index) {
      const that = this;
      return function (response) {
        Log('response', index, response);
        if (response.code === '0') {
          that.inputVal.splice(index, 1, response.obj.url);
          let extra = that.list[index];
          that.$emit('inputChange', {
            [extra.id]: response.obj.attaId
          })
        }
      }
    },
    initInputVal() {
      if (this.data)
        this.data.forEach((rr, i) => {
          this.inputVal.splice(i, 1, rr.data || '');
        })
    }
  },
}
</script>

<style scoped lang="scss">
input {
  border: 0px none;
  width: 60px;
  border-bottom: 1px #cccccc solid;
  padding: 0px 5px;
  outline: none;
}

.avatar-uploader-icon {
  width: 60px;
  height: 60px;
  border: 1px dashed #cccccc;
  border-radius: 5px;
  line-height: 60px;
}
</style>